import { theme } from '@chakra-ui/core';

const customTheme = {
  ...theme,
  fonts: {
    heading: 'Inter, sans-serif',
    body: "Inter, sans-serif",
    mono: "Menlo, monospace",
  }
}

export default customTheme;